import { Api } from "@/api";
import { UserLoginType } from "@/DTO";

export const CreateAdmin = (user: UserLoginType, phone: string, password: string, first_name: string, last_name: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `admin`,
      body: JSON.stringify(
        {
          phone: phone,
          password: password,
          first_name: first_name,
          last_name: last_name
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};